import { useState } from "react"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import LicenseFeatureGroupUpsertDialog from "@/v2-backoffice-client/license/featureGroup/LicenseFeatureGroupUpsertDialog"
import type { FeatureGroupFragment } from "@/v2-backoffice-client/license/featureGroup/__types__/license.featureGroup.fragment"

export type LicenseFeatureGroupUpsertMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  featureGroup: FeatureGroupFragment
}

// The board row menu's trigger for the package edit dialog (create goes
// through the board toolbar's New Package button, same dialog without a
// package).
function LicenseFeatureGroupUpsertMenuItem(
  props: LicenseFeatureGroupUpsertMenuItemProps,
) {
  const { featureGroup, children, ...menuItemProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ActionMenu.Item
        iconSrc="edit"
        data-feature-code="UI_BackofficeFeatureGroup_Row_Edit"
        onSelect={(e) => {
          e.preventDefault()
          setIsOpen(true)
        }}
        {...menuItemProps}
      >
        {children ?? "Update Package"}
      </ActionMenu.Item>

      <LicenseFeatureGroupUpsertDialog
        featureGroup={featureGroup}
        open={isOpen}
        onOpenChange={setIsOpen}
      />
    </>
  )
}

export default LicenseFeatureGroupUpsertMenuItem
